import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
    static values = {
        type: String,
        index: String,
        fields: Array,
        selectedMapping: String
    }

    connect() {
        let emailField = this.hubspotMappingFieldsController().defaultHubspotEmailFieldTarget.value
        let phoneField = this.hubspotMappingFieldsController().defaultHubspotPhoneFieldTarget.value

        this.removeDefaultMappings(emailField, phoneField, undefined);
    }

    removeDefaultMappings(emailField, phoneField, existingElement) {
        let type = this.typeValue
        let index = this.indexValue
        let fields = this.fieldsValue

        let mappingDiv = undefined
        if (existingElement !== undefined) {
            mappingDiv = document.querySelector(`.${existingElement}`)
        } else {
            mappingDiv = document.querySelector(
                `.mapping_field_${type}_${index}`,
            );
        }

        let selectedMapping = this.selectedMappingValue
        const selectElement = document.createElement("select");
        selectElement.classList.add("border", 'rounded-md', 'h-7', 'w-96', 'text-xs');
        selectElement.name = `user_integration[${type}_mappings][][hubspot_field_name]`;

        let filteredArray = fields.filter(field => field[0] != emailField && field[0] != phoneField)

        const existingSelect = mappingDiv.querySelector("select");
        const options = filteredArray.map((field) => ({value: field, label: field}));
        options.forEach((option) => {
            const opt = document.createElement("option");
            opt.value = option.value;
            opt.textContent = option.label;

            if (opt.value == selectedMapping) {
                opt.selected = true;
            }
            selectElement.appendChild(opt);
        });

        if (existingSelect) {
            existingSelect.replaceWith(selectElement);
        } else {
            mappingDiv.appendChild(selectElement);
        }
    }

    updateAllMappingFields() {
        let emailField = this.hubspotMappingFieldsController().defaultHubspotEmailFieldTarget.value
        let phoneField = this.hubspotMappingFieldsController().defaultHubspotPhoneFieldTarget.value
        this.allMappingsFields().forEach(el => this.removeDefaultMappings(emailField, phoneField, el.className))
    }

    allMappingsFields() {
        const all = document.querySelectorAll(".mapping-fields *")
        const matched = Array.from(all).filter(el =>
            Array.from(el.classList).some(cls => /^mapping_field_contact_\d+$/.test(cls))
        )

        return matched
    }

    hubspotMappingFieldsController() {
        const controller = document.querySelector("[data-controller~='hubspot-mapping-fields']")
        return this.application.getControllerForElementAndIdentifier(controller, "hubspot-mapping-fields")
    }
}
